import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, of, throwError } from 'rxjs';
import { RestService } from './rest.service';
import { AppConfigService } from './base/app-config.service';

@Injectable({
  providedIn: 'root',
})
export class ReportsService {
  // private apiBaseUrl = 'https://localhost:7159/api/';
  private apiBaseUrl: string = AppConfigService.settings.apiUrl;  
  data: any;

  constructor(private http: HttpClient, private rest: RestService) { }
  getCurrentFacilityId(): string {
    return localStorage.getItem('current_facility_id') || 'ES';
  }

  getTLRsForGivenBlueTagNumber(
    facilityId: string,
    blueTag: string,
    userCAI: string,
    isOldUser: boolean
  ): Observable<any> {
    const currentFacilityId = facilityId || this.getCurrentFacilityId();
    const url = `${this.apiBaseUrl
      }AirComplianceReport/GetTLRsForGivenBlueTagNumber?facilityId=${currentFacilityId}&blueTag=${encodeURIComponent(
        blueTag
      )}&isOldUser=${isOldUser}`;
    return this.http.get(url);
  }

  getTLRsForGivenBlueTagNumberExcel(p: any): Observable<any> {
    return this.rest.download(`AirComplianceReport/GetTLRsForGivenBlueTagNumberExcel`, p);
  }

  // find missing permanent repair date

  getMissingPermanentRepairDate(
    facilityId: string,
    userCAI: string
  ): Observable<any> {
    const url = `${this.apiBaseUrl}InspectorOAEngineerReport/GetMissingPermanentRepairDate?facilityId=${facilityId}&userCAI=${userCAI}`;
    return this.http.get(url);
  }

  getMissingPermanentRepairDateExcel(p: any): Observable<any> {
    return this.rest.download(`InspectorOAEngineerReport/GetMissingPermanentRepairDateExcel`, p);
  }

  //LDAR Fugitive Emission Report - Build Search

  getLDAREmissionbuildSearch(facilityId: string, isRetired: boolean): Observable<any> {
    const url = `${this.apiBaseUrl}AirComplianceReport/GetFugitiveEmissionDataSearch?facilityId=${facilityId}&isRetired=${isRetired}`;
    return this.http.get(url);
  }

  getLDAREmissionbuildSearchExcel(params: any): Observable<any> {
    return this.rest.downloadPost(`AirComplianceReport/GetLDARFugitiveEmissionReportExcel`, params, { responseType: 'blob' });
  }

  //Inspections Look Ahead Report

  getInspectionsLookAheadBuildSearch(
    facilityId: string,
    isRetired: boolean
  ): Observable<any> {
    const url = `${this.apiBaseUrl}InspectorOAEngineerReport/GetInspectionsLookAheadBuildSearch?facilityId=${facilityId}&isRetired=${isRetired}`;
    return this.http.get(url);
  }
  getInspectionsLookAheadBuildSearchExcel(p: any): Observable<any> {
    return this.rest.download(`InspectorOAEngineerReport/GetInspectionsLookAheadReportDataExcel`, p);
  }

  runReport(facilityId: string, userCAI: string, dateRange: number, repairType: string, division: string, section: string, plant: string, associatedPlant: string): Observable<any> {
    const url = `${this.apiBaseUrl}InspectorOAEngineerReport/GetInspectionsLookAheadReportData?facilityId=${facilityId}&userCAI=${userCAI}&dateRange=${dateRange}&repairType=${repairType}&division=${division}&section=${section}&plant=${plant}&associatedPlant=${associatedPlant}`;
    return this.http.get(url);
  }

  runReportFugitive(payload: any): Observable<any> {
    const url = `${this.apiBaseUrl}AirComplianceReport/GetLDARFugitiveEmissionReport`;
    return this.http.post(url, payload);
  }

  //Inspector CAI Report

  getInspectorCaiReport(
    facilityId: string,
    userCAI: string,
    cai: string
  ): Observable<any> {
    const url = `${this.apiBaseUrl}InspectorOAEngineerReport/GetInspectorCAIReport?facilityId=${facilityId}&userCAI=${userCAI}&CAI=${cai}`;
    return this.http.get(url);
  }


  validateInspectorCaiReport(userCai: string): Observable<any> {
    const url = `${this.apiBaseUrl}InspectorOAEngineerReport/ValidateUserInspectorReport?userId=${userCai}`;
    return this.http.get(url);
  }

  getInspectorCaiReportExcel(p: any): Observable<any> {
    return this.rest.download(`InspectorOAEngineerReport/GetInspectorCAIReportExcel`, p);
  }

  //Assigned Cai

  getCaiReport(
    flag: string,
    facilityId: string,
    userCAI: string,
    cai: string
  ): Observable<any> {
    const url = `${this.apiBaseUrl}InspectorOAEngineerReport/GetAssignedToCAIReport?flag=${flag}&facilityId=${facilityId}&userCAI=${userCAI}&CAI=${cai}`;
    return this.http.get(url);
  }


  getCaiReportExcel(p: { flag: string; facilityId: string; userCAI: string; CAI: string }): Observable<any> {
    const query = `flag=${p.flag}&facilityId=${p.facilityId}&userCAI=${p.userCAI}&CAI=${p.CAI}`;
    return this.rest.download(`InspectorOAEngineerReport/GetAssignedToCAIReportExcel?${query}`, null);
  }


  // inspected installed report
  getInspectedInstallReport(
    graphFlag: string,
    userCAI: string,
    facilityId: string,
    sectionName: string
  ): Observable<any> {
    const url = `${this.apiBaseUrl}InspectorOAEngineerReport/GetInspectedInstalledReport?graphFlag=${graphFlag}&userCAI=${userCAI}&facilityId=${facilityId}&sectionName=${sectionName}`;
    return this.http.get(url);
  }

  getInspectedInstallReportExcel(p: { graphFlag: string; facilityId: string; userCAI: string; sectionName: string }): Observable<any> {
    const query = `graphFlag=${p.graphFlag}&facilityId=${p.facilityId}&userCAI=${p.userCAI}&sectionName=${p.sectionName}`;
    return this.rest.download(`InspectorOAEngineerReport/GetInspectedInstalledReportExcel?${query}`, null);
  }


  // engineered installed report
  getEngineeredInstallReport(
    graphFlag: string,
    userCAI: string,
    facilityId: string,
    sectionName: string
  ): Observable<any> {
    const url = `${this.apiBaseUrl}InspectorOAEngineerReport/GetEngineeredInstalledReport?graphFlag=${graphFlag}&userCAI=${userCAI}&facilityId=${facilityId}&sectionName=${sectionName}`;
    return this.http.get(url);
  }

  getEngineeredInstallReportExcel(p: { graphFlag: string; facilityId: string; userCAI: string; sectionName: string }): Observable<any> {
    const query = `graphFlag=${p.graphFlag}&facilityId=${p.facilityId}&userCAI=${p.userCAI}&sectionName=${p.sectionName}`;
    return this.rest.download(`InspectorOAEngineerReport/GetEngineeredInstalledReportExcel?${query}`, null);
  }



  //permanent repair date within 90 days
  getRecommendedNinetyDaysReport(
    facilityId: string,
    userCAI: string
  ): Observable<any> {
    const url = `${this.apiBaseUrl}InspectorOAEngineerReport/GetRecommenedNinetyDaysReport?facilityId=${facilityId}&userCAI=${userCAI}`;
    return this.http.get(url);
  }

  getRecommendedNinetyDaysReportExcel(p: { facilityId: string; userCAI: string }): Observable<any> {
    const query = `facilityId=${p.facilityId}&userCAI=${p.userCAI}`;
    return this.rest.download(`InspectorOAEngineerReport/GetRecommenedNinetyDaysReportExcel?${query}`, null);
  }


  //inspector validation required

  getTLRRemovalVerification(
    facilityId: string,
    userCAI: string
  ): Observable<any> {
    const url = `${this.apiBaseUrl}InspectorOAEngineerReport/GetTLRRemovalVerification?facilityId=${facilityId}&userCAI=${userCAI}`;
    return this.http.get(url);
  }

  getTLRRemovalVerificationExcel(p: { facilityId: string; userCAI: string }): Observable<any> {
    const query = `facilityId=${p.facilityId}&userCAI=${p.userCAI}`;
    return this.rest.download(`InspectorOAEngineerReport/GetTLRRemovalVerificationExcel?${query}`, null);
  }
  
  //tlr given work order
  getTLRGivenWorkOrderReport(
    facilityId: string,
    workOrder: string,
    cai: string
  ): Observable<any> {
    const url = `${this.apiBaseUrl}InspectorOAEngineerReport/GetTLRGivenWorkOrderReport?facilityId=${facilityId}&workOrder=${workOrder}&cai=${cai}`;
    return this.http.get(url);
  }


  getTLRGivenWorkOrderReportExcel(p: {
    facilityId: string;
    workOrder: string;
    cai: string;
  }): Observable<any> {
    const query = `facilityId=${p.facilityId}&workOrder=${p.workOrder}&cai=${p.cai}`;
    return this.rest.download(`InspectorOAEngineerReport/GetTLRGivenWorkOrderReportExcel?${query}`, null);
  }


  //tlr installed report

  GetInspectOpenTLRReport(payload: any): Observable<any> {
    const query = `UserCAI=${payload.UserCAI}&FacilityID=${payload.FacilityID}&GraphFlag=${payload.GraphFlag}&Last7DaysFlag=${payload.Last7DaysFlag}&SectionName=${payload.SectionName}&PlantName=${payload.PlantName}&AssocPlantShutdown=${payload.AssocPlantShutdown}&DivisionName=${payload.DivisionName}&LeakingName=${payload.LeakingName}&MaterialStateName=${payload.MaterialStateName}&RepairTypeName=${payload.RepairTypeName}&Service=${payload.Service}&LDARFlag=${payload.LDARFlag}&StartDate=${payload.StartDate}&EndDate=${payload.EndDate}&InspCAI=${payload.InspCAI}`;
    return this.http.get(`${this.apiBaseUrl}InspectorOAEngineerReport/GetInspectOpenTLRReport?${query}`).pipe(
      
    );
  }


GetInspectOpenTLRReportExcel(payload: any): Observable<any> {
  return this.rest.downloadPost(`InspectorOAEngineerReport/GetInspectOpenTLRReportExcel`, payload);
}

}

